import createPage from './main.js'

import LandingPage from '@/views/LandingPage.vue'

createPage(LandingPage)
